// getGramWeightFromIngredients
export const getGramFromIngredients = (
  ingredients: { gram: null | number }[],
) => {
  const isGramInvalid = ingredients.some(
    (ingredient) => ingredient.gram === null || ingredient.gram === undefined,
  )

  if (isGramInvalid) {
    return 0
  }

  const gram = ingredients.reduce(
    (acc, ingredient) => acc + (ingredient.gram as number),
    0,
  )

  return gram
}
